<div class="notification__buttons notification__buttons--mobile">
  @if (ppNotification.markedAsRead) {
    <div
      class="notification__check notification__mark-as-read notification__button notification__button--read notification__enable-on-hover"
      ppTooltip
      [ppTitle]="'mark_as_unread' | ppTranslate"
      (click)="markAsUnread($event)"
      >
      <img
        class="notification__mark-as-unread-button notification__mark-as-read-button"
        [src]="EIconPath.NOTIFICATION_CHECK"
        />
      <pp-icon
        class="notification__mark-as-unread-button--hover notification__mark-as-read-button"
        [ppSrc]="EIconPath.NOTIFICATION_CHECK_PRIMARY"
        ppColor="primary-950"
        ></pp-icon>
    </div>
  }

  @if (!ppNotification.markedAsRead) {
    <div
      class="notification__check notification__mark-as-read notification__button"
      ppTooltip
      [ppTitle]="'mark_as_read' | ppTranslate"
      (click)="markAsRead($event)"
      >
      <img
        class="notification__check--hidden notification__mark-as-read-button"
        [src]="EIconPath.NOTIFICATION_CHECK"
        />
    </div>
  }

  <pp-notification-clear
    [ppActive]="ppNotification.markedAsRead"
    (ppCallback)="removeNotification($event)"
    [ppEnableOnHover]="false"
    [ppTooltipTitle]="'clear_notification'"
  ></pp-notification-clear>

  @if (
    (canRespond || ppNotification.changeBody?.cfFieldType === ECustomFieldType.RICHTEXT) &&
    !ppRespondingToComment &&
    !ppCommentSent &&
    commentsEditable
    ) {
    <div
      ppTooltip
      [ppTitle]="'respond' | ppTranslate"
      class="notification__button notification__respond"
      (click)="respond($event)"
      >
      <img class="notification__respond-image--grey" [src]="EIconPath.NOTIFICATION_RESPOND" />
      <pp-icon
        class="notification__respond-image--blue"
        [ppSrc]="EIconPath.NOTIFICATION_RESPOND_PRIMARY"
        ppColor="primary-950"
      ></pp-icon>
    </div>
  }

  @if (ppCommentSent && !ppRespondingToComment) {
    <div
      ppTooltip
      [ppTitle]="'comment_sent' | ppTranslate"
      class="notification__button notification__respond"
      >
      <img [src]="EIconPath.NOTIFICATION_SENT_TICK" />
    </div>
  }

  @if (
    (ppNotification.pushNotificationType === ENotificationType.POINT_EDITION_COMMENT ||
    ppNotification.pushNotificationType === ENotificationType.POINT_MENTION_COMMENT) &&
    ppNotification.changeBody?.commentId
    ) {
    <div
      ppTooltip
      [ppTitle]="ppReaction?.like.includes(activeUser.userId) ? 'Unlike comment' : 'Like comment'"
      (click)="likeComment($event)"
      class="notification__button notification__respond"
      >
      @if (ppReaction?.like.includes(activeUser.userId)) {
        <img
          [src]="EIconPath.INTERACTION_LIKE_FILLED"
          />
      }
      @if (!ppReaction?.like.includes(activeUser.userId)) {
        <img [src]="EIconPath.INTERACTION_LIKE" />
      }
    </div>
  }
</div>

<div class="notification__footer" (click)="openSite($event)">
  @if (pointData) {
    <div
      ppTooltip
      [ppTitle]="pointData.pointTitle"
      [ppTrimTooltip]="true"
      class="notification__point"
      (click)="openPoint()"
      >
      @if (ppNotification.pushNotificationType === ENotificationType.REACTION_COMMENT) {
        {{ ppNotification.reactionDetails.pointRef.sequenceNumber }} -
        {{ ppNotification.reactionDetails.pointRef.name }}
      }
      @if (ppNotification.pushNotificationType !== ENotificationType.REACTION_COMMENT) {
        {{ pointData.pointSequenceNumber }} -
        {{ pointData.pointTitle }}
      }
    </div>
    <span ppTooltip [ppTitle]="ppAccountName" [ppTrimTooltip]="true" class="notification__site">
      {{ ppAccountName }}
    </span>
    <span class="notification__site">
      <img class="notification__footer-arrow" [src]="EIconPath.ARROW_RIGHT_BLANK" />
    </span>
    <span
      ppTooltip
      [ppTitle]="ppNotification.siteName"
      [ppTrimTooltip]="true"
      class="notification__site"
      >
      {{ ppNotification.siteName }}
    </span>
  }

  <div class="notification__buttons notification__buttons--desktop">
    @if (!ppNotification.markedAsRead) {
      <div
        class="notification__check notification__mark-as-read notification__button notification__enable-on-hover"
        ppTooltip
        [ppTitle]="'mark_as_read' | ppTranslate"
        (click)="markAsRead($event)"
        >
        <img
          class="notification__check--hidden notification__mark-as-read-button"
          [src]="EIconPath.NOTIFICATION_CHECK"
          />
      </div>
    }

    @if (ppNotification.markedAsRead) {
      <div
        class="notification__check notification__mark-as-read notification__button notification__button--read notification__enable-on-hover"
        ppTooltip
        [ppTitle]="'mark_as_unread' | ppTranslate"
        (click)="markAsUnread($event)"
        >
        <img
          class="notification__mark-as-unread-button notification__mark-as-read-button"
          [src]="EIconPath.NOTIFICATION_CHECK"
          />
        <pp-icon
          class="notification__mark-as-unread-button--hover notification__mark-as-read-button"
          [ppSrc]="EIconPath.NOTIFICATION_CHECK_PRIMARY"
          ppColor="primary-950"
          ></pp-icon>
      </div>
    }

    <pp-notification-clear
      [ppActive]="ppNotification.markedAsRead"
      (ppCallback)="removeNotification($event)"
      [ppEnableOnHover]="true"
      [ppTooltipTitle]="'clear_notification'"
    ></pp-notification-clear>
  </div>
</div>
